// component/PrivateRoute.js
import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { LoaderContext } from '../context/LoaderContext';
import axiosinstance from '../axios/axiosInstance';
import Cookies from 'js-cookie';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [checkingPassword, setCheckingPassword] = useState(true);
  const [requiresPassword, setRequiresPassword] = useState(false);
  const location = useLocation();
  const user_id = Cookies.get('user_id');
  const token = Cookies.get('uid');

  useEffect(() => {
    if (loading || checkingPassword) {
      showLoader();
    } else {
      hideLoader();
    }
  }, [loading, checkingPassword, showLoader, hideLoader]);

  useEffect(() => {
    // Only check password if authenticated and not already on set-password page
    if (isAuthenticated && !loading && location.pathname !== '/set-password') {
      const checkPasswordStatus = async () => {
        try {
          const response = await axiosinstance.post("/user/check-password", { user_id }, {
            headers: {
              Authorization: token
            }
          });
          
          // Only require password if:
          // 1. User has email (for email login)
          // 2. User doesn't have password
          // 3. User is NOT phone-only (phone-only users use OTP, no password needed)
          if (response.data.requiresPassword === true) {
            setRequiresPassword(true);
          }
        } catch (err) {
          console.error("Error checking password:", err);
          // If error, allow access (don't block user)
        } finally {
          setCheckingPassword(false);
        }
      };

      checkPasswordStatus();
    } else {
      setCheckingPassword(false);
    }
  }, [isAuthenticated, loading, location.pathname, user_id, token]);

  if (loading || checkingPassword) {
    return null; // Global <Loader /> (animated logo) is shown via LoaderContext
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to set password if required
  if (requiresPassword && location.pathname !== '/set-password') {
    return <Navigate to="/set-password" replace />;
  }

  return children;
};

export default PrivateRoute;
